import React from 'react';
import { Image } from '@edreamsodigeo/prisma-design-system';
import type { Brands } from '@edreamsodigeo/frontend-core';
import { Show, useBrand } from '@edreamsodigeo/frontend-core';

import type { BrandLogoProps } from './types';
import { useBrandLogoUrl } from '~clientState/hooks';

const ALT_TEXT: Partial<Record<Brands, string> & { fallback: string }> = {
  ED: 'eDreams logo',
  OP: 'Opodo logo',
  GO: 'GoVoyages logo',
  fallback: 'Brand logo',
};

const BrandLogo = ({
  width,
  height,
  theme = 'default',
  type = 'primeLong',
}: BrandLogoProps) => {
  const brand = useBrand();
  const logoUrl = useBrandLogoUrl({ brand, theme, type });

  return (
    <Show when={Boolean(logoUrl)}>
      <Image
        size="auto"
        sx={{ width, height }}
        src={logoUrl}
        alt={ALT_TEXT[brand] || ALT_TEXT.fallback || ''}
      />
    </Show>
  );
};

export default BrandLogo;
